import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AcknowledgementService } from '../services/acknowledgement.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-acknowldgement-dialog',
  templateUrl: './acknowldgement-dialog.component.html',
  styleUrls: ['./acknowldgement-dialog.component.scss']
})
export class AcknowldgementDialogComponent {

  @Input() data: any;
  @Input() isOpen: boolean = false;
  @Output() closed = new EventEmitter<void>();

  constructor(
  private acknowledgeService: AcknowledgementService,
  private router: Router) { }

  closeDialog() {
    this.closed.emit();
  }

  userAcknowledgement(selectedData: any) {
    let req: any = {};
    req.acknowledgementId = this.data.id;
    req.consent = selectedData.consent;
    req.hasSeen = true;
    this.acknowledgeService.captureUserAcknowledgement(req).subscribe(response => {
      if (response) {
        this.closed.emit();
      }
    });
  }

  navigateAndClose(data: any) {
    this.closed.emit();

    const navigateProp = data.navigateTo.split('?')[0];
    const queryParamsString = data.navigateTo.split('?')[1];
    const queryParams = this.convertQueryParams(queryParamsString);
    this.router.navigate([navigateProp], { queryParams });
  }

  convertQueryParams(queryParamsString: string): { [key: string]: string } {
    const params = queryParamsString ? queryParamsString.split('&') : [];
    const queryParams: { [key: string]: string } = {};
    params.forEach(param => {
      const [key, value] = param.split('=');
      if (key && value) {
        queryParams[key] = value;
      }
    });
    return queryParams;
  }
}
